<template>
  <td @click="setFocus()" class="beam-table-cell-checkbox">
    <div class="d-flex align-center flex-row"
         ref="cell"
         :id="tab"
         :tabindex="tab"
         @keydown="keydownCell">
      <v-chip-group
        v-model="selection"
        selected-class="chip-selected"
        multiple
      >
        <v-chip v-for="(option, index) in tagsOptions"
                :disabled="$store.state.isWorkflowDisabled"
                :key="index"
                :value="option"
                :variant="selection && selection.includes(option) ? 'flat' : 'tonal'"
                color="grey-lighten-2"
                class="chip-option captures-description text-black"
                size="x-small"
        >
          {{ selection.includes(option) ? capitalizeFirstLetter(option) : 'Optional'}}
        </v-chip>
      </v-chip-group>
    </div>
  </td>
</template>

<script>
import { capitalizeFirstLetter } from '@/helpers/formatting'

export default {
  name: 'beam-table-cell-checkbox',

  props: {
    tags: Array,
    tab: Number
  },

  computed: {
    selection: {
      get: function () { return this.tags || [] },
      set: function (value) { this.$emit('set-tags', value) }
    }
  },

  data: function () {
    return {
      tagsOptions: ['REQUIRED']
    }
  },

  methods: {
    capitalizeFirstLetter,
    keydownCell (event) {
      switch (event.keyCode) {
        case 37: // left
        case 38: // up
        case 39: // right
        case 40: // down
        case 13: // enter
          this.$emit('leave-cell', event)
          break
        case 67: // c
          this.addTagToSelection(0)
          break
      }
      event.stopPropagation()
      event.preventDefault()
    },
    setFocus () {
      if (this.tab) {
        document.getElementById(`${this.tab}`).focus()
      }
    },
    addTagToSelection (tagOptionIndex) {
      if (!this.selection.includes(this.tagsOptions[tagOptionIndex])) {
        // Spread the array and add the new tag
        this.$emit('set-tags', [...this.selection, this.tagsOptions[tagOptionIndex]])
      } else {
        // Filter the array to remove the tag
        this.$emit('set-tags', this.selection.filter(e => e !== this.tagsOptions[tagOptionIndex]))
      }
    }
  }

}
</script>

<style scoped>
.beam-table-cell-checkbox{
  border-right: 1px solid #E5E3E1;
}
.chip-option {
  font-size: 12px !important;
}
</style>
